export default "__VITE_ASSET__8wyX56KN__"